import { useEffect } from "react";
import Page from "../../finwell/pages/Page";
import ComplianceReportSectionDetail from "../../components/Reports/complianceReport/ComplianceReportSectionDetail";
import CONFIG from "../../utils/config";

export const ComplianceReportDetailPageMobile = () => {

    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight+50 }
            console.log('height: ', obj);
            window.parent.postMessage(obj, "*");
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <div className="container pb-2rem">
        <ComplianceReportSectionDetail
            isMobile={true}
        />
        </div>
    );
};

export default ComplianceReportDetailPageMobile;
